var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleCalleeProfile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 43.5897,
    rx: 45,
    ry: 43.5897,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5002 43.4998C50.5983 43.4998 55.5418 38.5563 55.5418 32.4582C55.5418 26.36 50.5983 21.4165 44.5002 21.4165C38.402 21.4165 33.4585 26.36 33.4585 32.4582C33.4585 38.5563 38.402 43.4998 44.5002 43.4998Z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 49.021C33.4363 49.021 24.4263 56.441 24.4263 65.5835C24.4263 66.2018 24.9121 66.6877 25.5304 66.6877H63.4696C64.0879 66.6877 64.5738 66.2018 64.5738 65.5835C64.5738 56.441 55.5638 49.021 44.5 49.021Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleCalleeProfile2);
export default __webpack_public_path__ + "static/media/sample-callee-profile-2.9b556eb93709daa3860735e76a04ab64.svg";
export { ForwardRef as ReactComponent };